module.exports = __webpack_public_path__ + "static/media/s1-right.69d4a7b6.svg";